import styled from 'styled-components';
import { InlineFeedbackMixin } from '../../mixins/components/InlineFeedbackMixin';
export var StyledInlineFeedback = /*#__PURE__*/styled.p.withConfig({
  displayName: "StyledInlineFeedback",
  componentId: "c11n-8-111-1__sc-jcmz56-0"
})(["", ""], InlineFeedbackMixin);